import React, { useEffect, useState } from "react";
import "./Near_By_Events.css";
import Breadcrumb_Comp from "../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import Common_Title_1 from "../common/common_components/common_title_1/Common_Title_1";
import Common_Title_2 from "../common/common_components/common_title_2/Common_Title_2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import Show_Programs_Modal from "../common/modals/show_programs_modal/Show_Programs_Modal";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AllEvent } from "../../features/admin/common/Slice";
import { IDS } from "../../utils/IDS";
import { encodeId, formatDate, formatTime } from "../../utils/common";

const Near_By_Events = () => {
  const breadcrumbs = [
    { label: "EXPLORE", link: "/EXPLORE", active: false },
    { label: "NEAR BY EVENTS", link: "", active: true },
  ];

  const [showModal, setShowModal] = useState(false);

  const data = [
    {
      title: "Environment Day Awareness",
      address:
        "Om Tapovan Charitable Trust Borbhatha (Bet), Golden Bridge, Bharuch, Dist. Ankleshwar, Gujarat 393002 India",
      location: "Ankleshwar, India",
      lang: "Gujarati",
      date: "4 AUG 2025, 12:00 pm",
      img: "/assets/images/event_registration/near_by_events/img1.png",
    },
    {
      title: "Environment Day Awareness",
      address:
        "Om Tapovan Charitable Trust Borbhatha (Bet), Golden Bridge, Bharuch, Dist. Ankleshwar, Gujarat 393002 India",
      location: "Ankleshwar, India",
      lang: "Gujarati",
      date: "4 AUG 2025, 12:00 pm",
      img: "/assets/images/event_registration/near_by_events/img2.png",
    },
    {
      title: "Environment Day Awareness",
      address:
        "Om Tapovan Charitable Trust Borbhatha (Bet), Golden Bridge, Bharuch, Dist. Ankleshwar, Gujarat 393002 India",
      location: "Ankleshwar, India",
      lang: "Gujarati",
      date: "4 AUG 2025, 12:00 pm",
      img: "/assets/images/event_registration/near_by_events/img1.png",
    },
    {
      title: "Environment Day Awareness",
      address:
        "Om Tapovan Charitable Trust Borbhatha (Bet), Golden Bridge, Bharuch, Dist. Ankleshwar, Gujarat 393002 India",
      location: "Ankleshwar, India",
      lang: "Gujarati",
      date: "4 AUG 2025, 12:00 pm",
      img: "/assets/images/event_registration/near_by_events/img2.png",
    },
    {
      title: "Environment Day Awareness",
      address:
        "Om Tapovan Charitable Trust Borbhatha (Bet), Golden Bridge, Bharuch, Dist. Ankleshwar, Gujarat 393002 India",
      location: "Ankleshwar, India",
      lang: "Gujarati",
      date: "4 AUG 2025, 12:00 pm",
      img: "/assets/images/event_registration/near_by_events/img1.png",
    },
    {
      title: "Environment Day Awareness",
      address:
        "Om Tapovan Charitable Trust Borbhatha (Bet), Golden Bridge, Bharuch, Dist. Ankleshwar, Gujarat 393002 India",
      location: "Ankleshwar, India",
      lang: "Gujarati",
      date: "4 AUG 2025, 12:00 pm",
      img: "/assets/images/event_registration/near_by_events/img2.png",
    },
  ];

  const navigate = useNavigate()
  const location = useLocation();
  // console.log({ state: location });

  const dispatch = useDispatch();
  const events = useSelector((state) => state.common.all_events);

  useEffect(() => {
    dispatch(AllEvent({
      country_id: location.state?.country_id?.value,
      state_id: location.state?.state_id?.value,
    }));
  }, [dispatch, location?.state]);


  // console.log({ eventsevents: events });
  // useEffect(() => {
  //   if (location.state) {
  //     navigate(location.pathname, { replace: true, state: null });
  //   }
  // }, []);
  const locationText = [
    location?.state?.state_id?.label,
    location?.state?.country_id?.label,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <section className="Near_By_Events">
      <div className="container">
        <Breadcrumb_Comp data={breadcrumbs} />

        <Common_Title_1 subText={`Showing all programs ${locationText ? `at ${locationText}` : ""}`} />

        <div className="change_loc_div">
          <p className="change_location" onClick={() => { setShowModal(true) }}>Change Location</p>
        </div>

        <div className="all_programs_div">
          {events?.map((item) => {
            return (
              <div className="program_card" onClick={() => { navigate(`/program-details/${encodeId(item?.event_id)}`) }}>
                <div className="row ">
                  <div className="col-xl-2 col-md-2 col-sm-7 col-6 mb-md-0  mb-sm-3">
                    <div className="left_img_div">
                      <img src={IDS.IMG_URL + item?.Event?.image} className="left_img" />
                    </div>
                  </div>
                  <div className="col-xl-8 col-md-7 order-md-2 order-sm-3">
                    <div className="content_div">
                      <p className="title_text">{item?.name}</p>

                      <div className="img_text_div">
                        <img
                          src="/assets/images/event_registration/near_by_events/location.png"
                          className="inner_img"
                        />
                        <p className="inner_text">{[
                          item?.Event?.Contact_us_centre?.address,
                          item?.Event?.Contact_us_centre?.Area?.name,
                          item?.Event?.Contact_us_centre?.City?.name,
                          item?.Event?.Contact_us_centre?.State?.name,
                          item?.Event?.Contact_us_centre?.Country?.name,
                        ]
                          .filter(Boolean)
                          .join(", ")}</p>
                      </div>

                      <div className="img_text_div without_mb">
                        <img
                          src="/assets/images/event_registration/near_by_events/bank.png"
                          className="inner_img"
                        />
                        <p className="inner_text">{[

                          item?.Event?.State?.name,
                          item?.Event?.Country?.name,
                        ]
                          .filter(Boolean)
                          .join(", ")}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-2 col-md-3 col-sm-5 order-md-3 order-sm-2">
                    <div className="right_div">
                      <p className="date_text">
                        <FontAwesomeIcon
                          icon={faCalendarDays}
                          className="date_icon"
                        />
                        {formatDate(item.Event?.start_date, true)} at {formatTime(item?.Event?.start_time) || ""}
                      </p>

                      <div className="img_text_div">
                        {/*<img
                          src="/assets/images/event_registration/near_by_events/lang.png"
                          className="inner_img"
                        />
                       <p className="inner_text">{item?.lang}</p> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <Show_Programs_Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </section>
  );
};

export default Near_By_Events;
